import { Component } from "@angular/core";

@Component({
    selector: 'icon-clip[ui-kit]',
    template: `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5 9.5L9.3 16.7a4 4 0 01-5.66-5.66L11 3.66a2.67 2.67 0 013.77 3.77L7.4 14.8a1.33 1.33 0 01-1.89-1.88L12 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `,
})
export class IconClip {}
